import { token } from '@cp/shared/di';
import { IModalManager } from './manager.interface';

export const MODAL_MANAGER = token<IModalManager>('MODAL_MANAGER');
